const DEFAULT_HOOKS = ['activate', 'mount', 'update'];

export { DEFAULT_HOOKS };
//# sourceMappingURL=constants.js.map



// WEBPACK FOOTER //
// ./~/@sentry/vue/esm/constants.js